import useAttendances, { POR_PAGINA } from './useAttendances';
import { ReadOnlyBanner } from 'components/ReadOnlyGuard';
import CuorumPanel from 'components/CuorumPanel';
import SearchableSelect from 'components/SearchableSelect';
import PropertyCombobox from 'components/PropertyCombobox';
import RepresentativeModal from './RepresentativeModal';
import RepresentaAModal from './RepresentaAModal';
import DarPoderModal from './DarPoderModal';
import ConfirmDeleteModal from 'components/ConfirmDeleteModal';
import Paginacion from 'components/Paginacion';
import styles from './Attendances.module.css';

// ── Componente principal ───────────────────────────────────────────────────────

export default function Attendances() {
  const {
    items, busqueda, setBusqueda, setPagina, loading, alert, setAlert, assemblies, filterProp,
    filterAsm, loadingAsm, repModal, setRepModal, representaModal, setRepresentaModal, darPoderModal,
    setDarPoderModal, confirmDel, setConfirmDel, deleting, delError, setDelError, isAssemblyAdmin, 
    selectedAsm_, asmFinalizada, sinAcciones, selectedPropBlocked, handleFilterProp, handleFilterAsm,
    toggleExterno, toggleStatus, del, onRepSaved, poderPorUnidad, representaDe, numeroUnidad, filasDe,
    selectedAsm, needsPropSelect, showAsmSelect, selectedPropName, pstate, filasFiltradas, paginaActual,
    filasPagina, irAPagina, totalPresent, totalRetirado, totalRep, totalAbsent, pctPresent, BASE_URL,
  } = useAttendances();

  return (
    <div>
      <div className="page-header">
        <div>
          <h1><i className={`fas fa-clipboard-list ${styles.iconoTitulo}`} />Asistentes</h1>
          <p>
            {filterAsm && selectedAsm
              ? `Asamblea #${selectedAsm.number_assembly}${selectedAsm.property?.name ? ` · ${selectedAsm.property.name}` : (selectedPropName ? ` · ${selectedPropName}` : '')}`
              : needsPropSelect && !filterProp
                ? 'Selecciona una propiedad y una asamblea'
                : selectedPropName
                  ? `${selectedPropName} — selecciona una asamblea`
                  : 'Selecciona una asamblea'}
          </p>
        </div>
        {/* Selectores solo para admin/super_admin — assembly_admin ve su asamblea automáticamente */}
        {!isAssemblyAdmin && (
          <div className={styles.selectores}>
            {/* Filtro propiedad — super_admin y admin multi-propiedad */}
            {needsPropSelect && (
              <div className={styles.grupoSelector}>
                <i className={`fas fa-building ${styles.iconoSelector}`} />
                <PropertyCombobox value={filterProp} onChange={handleFilterProp} placeholder="— Selecciona propiedad —" />
                {filterProp && (
                  <button className="btn btn-sm btn-secondary btn-icon" onClick={() => handleFilterProp('')} title="Limpiar">
                    <i className="fas fa-times" />
                  </button>
                )}
              </div>
            )}

            {/* Filtro asamblea */}
            {showAsmSelect && (
              <div className={styles.grupoSelector}>
                <i className={`fas fa-gavel ${styles.iconoSelector}`} />
                {loadingAsm ? (
                  <div className={`spinner ${styles.spinnerChico}`} />
                ) : (
                  <SearchableSelect value={filterAsm} onChange={(id) => handleFilterAsm(id)} placeholder="— Selecciona una asamblea —" minWidth={240} maxWidth={300} ariaLabel="Asamblea"
                    options={assemblies.map(a => ({ value: a.id, label: `#${a.number_assembly} · ${a.property?.name || selectedPropName || `Propiedad #${a.property_id}`}${a.status === 'en_progreso' ? ' 🟢' : a.status === 'finalizada' ? ' ✓' : ' ⏳'}` }))} />
                )}
              </div>
            )}
          </div>
        )}
      </div>

      <ReadOnlyBanner />
      {asmFinalizada && (
        <div className={`alert alert-info ${styles.alertaMargen}`}>
          <i className="fas fa-lock" /> Esta asamblea ya finalizó: la asistencia es la del acta y no se puede cambiar. Si hay que corregirla, reabre la asamblea.
        </div>
      )}
      {selectedPropBlocked && (
        <div className={styles.bannerBloqueo}>
          <i className={`fas fa-ban ${styles.bannerBloqueoIcono}`} />
          <span>
            <strong>Acceso bloqueado.</strong> La membresía de esta propiedad ha vencido
            y el período de gracia ha expirado. No se pueden gestionar asistentes hasta renovar.
          </span>
        </div>
      )}
      {alert && (
        <div className={`alert alert-${alert.type} ${styles.alertaClic}`} onClick={() => setAlert(null)}>
          {alert.message}
        </div>
      )}

      {!filterAsm && (
        <div className="card"><div className="empty-state">
          <i className={`fas ${needsPropSelect && !filterProp ? 'fa-building' : 'fa-gavel'} ${styles.iconoVacio}`} />
          <p className={styles.textoVacio}>
            {needsPropSelect && !filterProp
              ? 'Selecciona una propiedad y luego una asamblea para ver los asistentes'
              : 'Selecciona una asamblea para ver los asistentes'}
          </p>
        </div></div>
      )}

      {filterAsm && loading && <div className="loading"><div className="spinner" /></div>}

      {filterAsm && !loading && (
        <>
          {/* KPIs */}
          {items.length > 0 && (
            <div className={`kpi-grid-6 ${styles.kpiGrid}`}>
              {[
                { label: 'Convocados',      value: items.length,     color: '#6c63ff', icon: 'fa-users' },
                { label: 'Presentes ahora', value: totalPresent,     color: '#12b76a', icon: 'fa-user-check' },
                { label: 'Retirados',       value: totalRetirado,    color: '#f79009', icon: 'fa-user-clock' },
                { label: 'Representados',   value: totalRep,         color: '#6c63ff', icon: 'fa-user-friends' },
                { label: 'Ausentes',        value: totalAbsent,      color: '#f04438', icon: 'fa-user-xmark' },
                { label: 'Unidades presentes',  value: `${pctPresent}%`, color: 'var(--accent)', icon: 'fa-percent' },
              ].map(k => (
                <div key={k.label} className={styles.kpi}>
                  <div className={styles.kpiIcono} style={{ '--tono': k.color, '--fondo': k.color + '22' }}>
                    <i className={`fas ${k.icon} ${styles.kpiGlifo}`} />
                  </div>
                  <div>
                    <div className={styles.kpiValor}>{k.value}</div>
                    <div className={styles.notaChica}>{k.label}</div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* F-17 (a): cuórum de ley sobre el total del conjunto + "Verificar cuórum" */}
          {selectedAsm_ && <CuorumPanel assembly={selectedAsm_} puedeVerificar={!sinAcciones} />}

          {/* Barra quórum */}
          {items.length > 0 && (
            <div className={`card ${styles.barraCard}`}>
              <div className={styles.barraFila}>
                <span className={styles.barraTitulo}>Progreso de asistencia</span>
                <span className={styles.barraConteo}>{totalPresent} de {items.length}</span>
              </div>
              <div className={styles.barraPista}>
                <div className={styles.barraRelleno} style={{
                  '--tono': pctPresent >= 50 ? '#12b76a' : pctPresent >= 30 ? '#f79009' : '#f04438',
                  '--ancho': `${pctPresent}%`,
                }} />
              </div>
            </div>
          )}

          {/* Tabla */}
          {items.length === 0 ? (
            <div className="card"><div className="empty-state">
              <i className="fas fa-clipboard-list" />
              <p>No hay asistentes para esta asamblea</p>
            </div></div>
          ) : (
            <div className="card">
              <div className={`card-header ${styles.cabeceraLista}`}>
                <h2>Lista de asistentes</h2>
                <div className={styles.badges}>
                  <span className={`badge ${styles.badgePresentes}`}>
                    {totalPresent} presentes ahora
                  </span>
                  {totalRetirado > 0 && (
                    <span className={`badge ${styles.badgeRetirados}`}>
                      {totalRetirado} retirados
                    </span>
                  )}
                  {totalRep > 0 && (
                    <span className={`badge ${styles.badgeRep}`}>
                      {totalRep} representados
                    </span>
                  )}
                  <span className="badge badge-secondary">{totalAbsent} ausentes</span>
                </div>
                <div className={styles.buscador}>
                  <i className={`fas fa-search ${styles.buscadorIcono}`} />
                  <input
                    type="text"
                    className={`form-control ${styles.campoBuscador}`}
                    aria-label="Buscar asistente"
                    placeholder="Buscar nombre, documento o unidad..."
                    value={busqueda}
                    onChange={e => { setBusqueda(e.target.value); setPagina(1); }}
                  />
                </div>
              </div>
              <div className="table-wrapper">
                <table className="tabla-tarjetas" role="table">
                  <thead>
                    <tr role="row">
                      <th role="columnheader">Propietario</th>
                      <th role="columnheader">Unidad</th>
                      <th role="columnheader">Torre</th>
                      <th role="columnheader">Estado</th>
                      <th role="columnheader">Poder</th>
                      <th role="columnheader">Ingreso / salida</th>
                      {!sinAcciones && <th role="columnheader" className={styles.thCentro}>Acciones</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {filasPagina.map((item, idx) => {
                      const isPresent = item.status === 'present';
                      const poder     = poderPorUnidad.get(Number(item.unit_id)) || null; // poder que cubre esta unidad
                      const representa = representaDe(item);
                      const st        = pstate(item);
                      const stCfg = {
                        presente: { bg: '#12b76a22', color: '#12b76a', icon: 'fa-circle-check',  label: 'Presente' },
                        retirado: { bg: '#f7900922', color: '#b45309', icon: 'fa-user-clock',     label: 'Retirado' },
                        ausente:  { bg: '#f0443822', color: '#f04438', icon: 'fa-circle-xmark',   label: 'Ausente' },
                      }[st];
                      const mins = item.last_seen_at
                        ? Math.floor((Date.now() - new Date(item.last_seen_at).getTime()) / 60000)
                        : null;
                      return (
                        <tr key={item.id} role="row" className={idx % 2 === 0 ? undefined : styles.filaImpar}>
                          <td role="cell" data-label="Propietario">
                            {item.owner ? (
                              <div>
                                <div className={styles.nombre}>{item.owner.nombre} {item.owner.apellido}</div>
                                <div className={styles.documento}>{item.owner.numero_identificacion}</div>
                              </div>
                            ) : <span className={styles.sinDato}>—</span>}
                          </td>
                          <td role="cell" data-label="Unidad" className={styles.celdaUnidad}>{item.unit?.numero_unidad || '—'}</td>
                          <td role="cell" data-label="Torre" className={styles.celdaTorre}>{item.unit?.building?.numero_torre || '—'}</td>
                          <td role="cell" data-label="Estado">
                            <span className={styles.chipEstado} style={{ '--fondo': stCfg.bg, '--tono': stCfg.color }}>
                              <i className={`fas ${stCfg.icon} ${styles.chipIcono}`} />
                              {stCfg.label}
                            </span>
                            {st === 'retirado' && !item.exit_time && mins != null && (
                              <div className={styles.notaChica}>
                                hace {mins} min sin conexión
                              </div>
                            )}
                            {st === 'retirado' && item.exit_time && (
                              <div className={styles.notaChica}>
                                salió {new Date(item.exit_time).toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' })}
                              </div>
                            )}
                          </td>
                          <td role="cell" data-label="Poder">
                            {poder && (
                              <div>
                                <div className={styles.poderEtiqueta}>Delegó a</div>
                                <div className={styles.poderNombre}>{poder.rep_nombre}</div>
                                <div className={styles.documento}>
                                  {poder.rep_es_externo ? 'Persona externa' : 'Propietario'} · {poder.rep_numero_documento}
                                </div>
                                {poder.id === item.id && poder.rep_path_documento && (
                                  <a href={`${BASE_URL}${poder.rep_path_documento}`} target="_blank" rel="noreferrer"
                                    className={styles.enlaceDocumento}>
                                    <i className="fas fa-file-alt" />
                                    Ver documento
                                  </a>
                                )}
                              </div>
                            )}
                            {representa.length > 0 && (
                              <span className={`${styles.chipRep} ${poder ? styles.chipRepConPoder : ''}`}>
                                <i className={`fas fa-user-friends ${styles.chipIcono}`} />
                                Representa a: {[...new Set(representa)].map(numeroUnidad).join(', ')}
                              </span>
                            )}
                            {!poder && representa.length === 0 && (
                              <span className={styles.sinPoder}>—</span>
                            )}
                          </td>
                          <td role="cell" data-label="Ingreso / salida" className={styles.celdaHoras}>
                            {/* Horas calculadas por el servidor con la regla del acta
                                (hora_ingreso / hora_salida): una unidad delegada lleva las de
                                su representante — así se evita la hora falsa de las filas
                                delegadas que motivó la #7, y se ve cuándo entró y cuándo
                                salió (o se le quitó el poder) quien ya no está. */}
                            {item.hora_ingreso
                              ? <>
                                  {new Date(item.hora_ingreso).toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' })}
                                  {item.hora_salida && (
                                    <span> → {new Date(item.hora_salida).toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' })}</span>
                                  )}
                                </>
                              : '—'}
                          </td>
                          {!sinAcciones && (
                            <td role="cell" data-label="Acciones" className="celda-acciones">
                              <div className={`actions ${styles.acciones}`}>
                                {poder ? (
                                  // Unidad cubierta por un poder: su presencia la da el poder, así que
                                  // no se ofrece Presente/Ausente (antes ese botón cambiaba la fila a
                                  // 'personal' y desactivaba el poder sin avisar). Se cambia con "Quitar poder".
                                  <button className={`btn btn-sm btn-secondary ${styles.botonMorado}`}
                                    onClick={() => setRepModal({ attendance: poder, ownerRows: filasDe(poder), unitId: Number(item.unit_id) })}
                                    title="Ver o quitar el poder">
                                    <i className="fas fa-file-signature" />
                                    Ver poder
                                  </button>
                                ) : null}
                                {poder && poder.rep_es_externo && (() => {
                                  const extPresente = pstate(poder) === 'presente';
                                  return (
                                    <button className={`btn btn-sm ${extPresente ? 'btn-warning' : 'btn-success'}`}
                                      onClick={() => toggleExterno(poder)}
                                      title={`Marcar a ${poder.rep_nombre || 'el representante'} (todas las unidades que representa)`}>
                                      <i className={`fas ${extPresente ? 'fa-user-xmark' : 'fa-user-check'}`} />
                                      {extPresente ? 'Ausente' : 'Presente'}
                                    </button>
                                  );
                                })()}
                                {!poder && (
                                  <>
                                    <button className={`btn btn-sm ${isPresent ? 'btn-warning' : 'btn-success'}`}
                                      onClick={() => toggleStatus(item)}>
                                      <i className={`fas ${isPresent ? 'fa-user-xmark' : 'fa-user-check'}`} />
                                      {isPresent ? 'Ausente' : 'Presente'}
                                    </button>
                                    {item.owner && (
                                      <button className={`btn btn-sm btn-secondary ${styles.botonMorado}`}
                                        onClick={() => setRepresentaModal(item)}
                                        title="Esta persona trae poderes de otros propietarios">
                                        <i className="fas fa-user-friends" />
                                        Representa a…
                                      </button>
                                    )}
                                    {item.owner && (
                                      <button className={`btn btn-sm btn-secondary ${styles.botonMorado}`}
                                        onClick={() => setDarPoderModal(item)}
                                        title="Este propietario entrega su voto a otra persona">
                                        <i className="fas fa-file-signature" />
                                        Dar poder a…
                                      </button>
                                    )}
                                  </>
                                )}
                                <button className="btn btn-sm btn-danger btn-icon" onClick={() => setConfirmDel(item)} title="Eliminar" aria-label="Eliminar">
                                  <i className="fas fa-trash" />
                                </button>
                              </div>
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {filasFiltradas.length === 0 && (
                  <div className="empty-state"><i className="fas fa-search" /><p>Sin resultados para "{busqueda}"</p></div>
                )}
              </div>
            </div>
          )}
          {items.length > 0 && <Paginacion pagina={paginaActual} total={filasFiltradas.length} porPagina={POR_PAGINA} onCambiar={irAPagina} />}
        </>
      )}

      {/* Modal representante */}
      {repModal && (
        <RepresentativeModal
          attendance={repModal.attendance}
          ownerRows={repModal.ownerRows}
          unitId={repModal.unitId}
          onClose={() => setRepModal(null)}
          onSaved={onRepSaved}
        />
      )}

      {darPoderModal && (
        <DarPoderModal
          giverItem={darPoderModal}
          items={items}
          assemblyId={filterAsm}
          onClose={() => setDarPoderModal(null)}
          onSaved={onRepSaved}
        />
      )}

      {representaModal && (
        <RepresentaAModal
          repItem={representaModal}
          items={items}
          assemblyId={filterAsm}
          onClose={() => setRepresentaModal(null)}
          onSaved={onRepSaved}
        />
      )}

      {confirmDel && (
        <ConfirmDeleteModal title="Eliminar registro de asistencia" onClose={() => { setConfirmDel(null); setDelError(''); }} onConfirm={del} deleting={deleting} error={delError}>
          <div className={styles.confirmaPregunta}>
            {confirmDel.owner
              ? <>¿Eliminar el registro de <span className={styles.confirmaNombre}>{confirmDel.owner.nombre} {confirmDel.owner.apellido}</span>?</>
              : '¿Eliminar este registro de asistencia?'}
          </div>
        </ConfirmDeleteModal>
      )}
    </div>
  );
}
